<div [matTooltip]="'Group node'" [matTooltipPosition]="'before'">
  <button
    mat-icon-button
    [class.active]="active"
    [y42Permission]="state.isCanvasEditable"
    [permissionTooltip]="'You do not have permission to edit the asset'"
    [intercomTarget]="'toolbar-insert-group-nodes'"
    (click)="selectTool.emit()"
  >
    <fa-icon [icon]="['fal', 'share-nodes']"></fa-icon>
  </button>
</div>
